import React from 'react';
import { ArrowUpRight, ArrowDownRight } from 'lucide-react';
interface KpiCardProps {
  title: string;
  value: string | number;
  target?: string | number;
  delta?: number;
  deltaType?: 'positive' | 'negative' | 'neutral';
  progress?: number;
}
export function KpiCard({
  title,
  value,
  target,
  delta,
  deltaType,
  progress
}: KpiCardProps) {
  return <div className="card p-5 flex flex-col" data-id="element-764">
      <h3 className="text-[13px] font-medium text-growthly-muted mb-2" data-id="element-765">
        {title}
      </h3>
      <div className="flex items-end justify-between mb-4" data-id="element-766">
        <div className="flex items-baseline space-x-2" data-id="element-767">
          <span className="text-[28px] font-bold text-growthly-text leading-none" data-id="element-768">
            {value}
          </span>
          {target && <span className="text-[13px] text-growthly-muted" data-id="element-769">/ {target}</span>}
        </div>
        {delta !== undefined && <div className={`flex items-center text-[12px] font-medium ${deltaType === 'positive' ? 'text-growthly-green' : deltaType === 'negative' ? 'text-growthly-red' : 'text-growthly-muted'}`} data-id="element-770">
            {delta > 0 ? <ArrowUpRight className="w-3 h-3 mr-1" data-id="element-771" /> : delta < 0 ? <ArrowDownRight className="w-3 h-3 mr-1" data-id="element-772" /> : null}
            {Math.abs(delta)}%
          </div>}
      </div>

      {progress !== undefined && <div className="w-full bg-white/10 rounded-full h-2 mt-auto" data-id="element-773">
          <div className={`h-2 rounded-full ${progress >= 100 ? 'bg-growthly-green' : 'bg-growthly-text'}`} style={{
        width: `${Math.min(progress, 100)}%`
      }} data-id="element-774"></div>
        </div>}
    </div>;
}